import React from "react";
import { Modal, Button } from "antd";
import { useSelector } from "react-redux";
import { callNotification } from "../../../../redux/constants";

const DeleteWidget = ({ handleChange, isModalShow, modalText, sectionId }) => {
  const handleOk = (e) => {
    handleChange(false, e);
  };
  const handleCancel = (e) => {
    handleChange(false, e);
  };
  const authParams = useSelector((state) => state.Authentication.authParams);

  const Section = useSelector((state) => state.Section.addSection);

  let sectionData = Section?.find((section) => section.id === sectionId);

  return (
    <Modal
      title={""}
      visible={isModalShow}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button
          type="button"
          className="btn_Clear"
          style={{ minWidth: "5.6rem" }}
          onClick={() => handleCancel("no")}
        >
          NO
        </Button>,
        <Button
          type="primary"
          className="ant-btn-primary_blue"
          onClick={() => handleOk("yes")}
        >
          YES
        </Button>,
      ]}
      width={580}
      closable={false}
      maskClosable={false}
      bodyStyle={{ padding: "3rem" }}
      className={authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"}
    >
      <div className="text_heading-Slab text-transform__none">
        {sectionData?.data?.length === 1
          ? " Deleting this widget will delete the corresponding section too are you sure you want to delete this widget?"
          : modalText}
      </div>
    </Modal>
  );
};

export default DeleteWidget;
